import { DefaultTheme } from "styled-components";

import { TColorScheme } from "../colors.types";

export const getLightStyledTheme = (colors: TColorScheme): DefaultTheme => {
  return {
    features: {
      firstBillingModal: {
        bgColor: `linear-gradient(0deg, ${colors.white} 50%, ${colors.neutral[200]} 50%)`,
      },
      dashboard: {
        branchsInformation: {
          bgColor: colors.white,
        },
        installationListMap: {
          subtitleColor: colors.neutral[500],
          skeletonBgColor: colors.white,
          popupBgColor: colors.white,
          linkButton: {
            bgColor:
              "linear-gradient(39.68deg, #293138 0%, rgba(41, 49, 56, 0.75) 92.27%)",
            iconColor: colors.neutral[300],
            hoverIconColor: colors.white,
          },
        },
        missedAdvantage: {
          borderColor: colors.neutral[300],
          titleColor: colors.neutral[1200],
          descriptionColor: colors.neutral[600],
          changeTariffButton: {
            bgColor: colors.neutral[200],
            color: colors.neutral[1100],
            selectedBgColor: colors.neutral[1100],
            selectedColor: colors.white,
          },
        },
        notBillingFoundCard: {
          hoverBgColor: "rgba(165, 100, 247, 20%)",
          hoverColor: colors.secondary[800],
          buttonBgColor: colors.secondary[800],
          buttonHoverColor: colors.secondary[500],
        },
        fineCard: {
          borderColor: colors.neutral[200],
          error: {
            numberColor: colors.error[600],
            titleColor: colors.error[400],
            badgeBgColor: colors.white,
            badgeNumberColor: colors.error[600],
            badgeNameColor: colors.error[400],
            badgeIconColor: colors.error[700],
            badgeBorderColor: colors.error[300],
          },
          gray: {
            numberColor: colors.neutral[700],
            titleColor: colors.neutral[600],
            badgeBgColor: colors.neutral[100],
            badgeNumberColor: colors.neutral[600],
            badgeNameColor: colors.neutral[500],
            badgeIconColor: colors.neutral[500],
            badgeBorderColor: colors.neutral[400],
          },
        },
        summaryGraph: {
          titleColor: colors.neutral[1000],
          barColors: [colors.secondary[500], colors.primary[400]],
          barBgColor: colors.white,
        },
        summaryCard: {
          footerColor: colors.neutral[600],
          footerBgColor: colors.neutral[100],
          footerNumberColor: colors.neutral[900],
          footerBorderColor: colors.neutral[300],
          primary: {
            titleColor: colors.primary[700],
            numberColor: colors.neutral[1100],
            decimalColor: colors.neutral[400],
            unitColor: colors.neutral[300],
            subtitleColor: colors.neutral[500],
            iconColor: colors.primary[700],
            iconBorderColor: colors.primary[300],
            iconBgColor: colors.primary[100],
            progressColor: colors.primary[500],
            progressStrokeColor: colors.primary[500],
            progressDangerColor: colors.primary[700],
            progressStrokeDangerColor: colors.primary[700],
            footerNumberColor: colors.primary[600],
            footerBadgeColor: colors.primary[600],
            footerBadgeBgColor: colors.primary[100],
            switchBgColor: colors.primary[700],
            switchColor: colors.white,
            switchHandleColor: colors.white,
          },
          secondary: {
            titleColor: colors.secondary[700],
            numberColor: colors.neutral[1100],
            decimalColor: colors.neutral[400],
            unitColor: colors.neutral[300],
            subtitleColor: colors.neutral[500],
            iconColor: colors.secondary[700],
            iconBorderColor: colors.secondary[300],
            iconBgColor: colors.secondary[100],
            progressColor: colors.secondary[600],
            progressStrokeColor: colors.secondary[500],
            progressDangerColor: colors.secondary[800],
            progressStrokeDangerColor: colors.secondary[800],
            footerNumberColor: colors.secondary[600],
            footerBadgeColor: colors.secondary[600],
            footerBadgeBgColor: colors.secondary[100],
            switchBgColor: colors.neutral[700],
            switchColor: colors.white,
            switchHandleColor: colors.white,
          },
          gray: {
            titleColor: colors.neutral[700],
            numberColor: colors.neutral[600],
            decimalColor: colors.neutral[400],
            unitColor: colors.neutral[500],
            subtitleColor: colors.neutral[600],
            iconColor: colors.neutral[500],
            iconBorderColor: colors.neutral[300],
            iconBgColor: colors.neutral[200],
            progressColor: colors.neutral[200],
            progressStrokeColor: colors.neutral[200],
            progressDangerColor: colors.neutral[200],
            progressStrokeDangerColor: colors.neutral[200],
            footerNumberColor: colors.neutral[600],
            footerBadgeColor: colors.neutral[700],
            footerBadgeBgColor: colors.neutral[200],
            switchBgColor: colors.neutral[200],
            switchColor: colors.neutral[400],
            switchHandleColor: colors.neutral[400],
          },
        },
      },
      alarms: {
        tableExpandIconColor: colors.neutral[700],
        tableExpandIconDotColor: colors.primary[500],
        customErrorColor: colors.error[500],
        dividerColor: colors.neutral[200],
        alarmSwitch: {
          critical: {
            iconColor: colors.error[300],
            lineColor: colors.error[500],
          },
          warning: {
            iconColor: colors.warning[300],
            lineColor: colors.warning[500],
          },
          info: {
            iconColor: colors.info[300],
            lineColor: colors.info[500],
          },
        },
        userTag: {
          email: {
            color: colors.primary[500],
          },
          sms: {
            color: colors.secondary[500],
          },
        },
      },
      billings: {
        billingTotalCard: {
          titleColor: colors.neutral[800],
          dividerColor: colors.neutral[200],
          tariffButtonBgColor: colors.error[400],
          tariffButtonColor: colors.white,
          neutral: {
            numberColor: colors.neutral[1000],
            decimalColor: colors.neutral[600],
            unitColor: colors.neutral[1000],
          },
          success: {
            numberColor: colors.primary[400],
            decimalColor: colors.primary[400],
            unitColor: colors.primary[400],
          },
          error: {
            numberColor: colors.error[400],
            decimalColor: colors.error[400],
            unitColor: colors.error[400],
          },
        },
        billingTabs: {
          billingGraphColors: [
            colors.primary[400],
            colors.secondary[500],
            colors.neutral[1000],
          ],
          billingDetailGraphColors: [
            colors.primary[500],
            colors.secondary[500],
            colors.secondary[700],
            colors.neutral[300],
            colors.neutral[500],
            colors.neutral[700],
            colors.neutral[900],
            colors.secondary[300],
            colors.primary[700],
          ],
          billingUnitPriceGraphColors: [
            colors.primary[500], colors.secondary[500],
          ],
        },
        billingDetails: {
          header: {
            dateInfoBox: {
              bgColor: colors.neutral[200],
              innerBoxBgColor: colors.white,
              color: colors.neutral[1000],
            },
            chevronIconColor: colors.neutral[800],
          },
          pieChart: {
            borderColor: colors.white,
            color: colors.neutral[1100],
            chartColors: [
              colors.primary[500],
              colors.primary[400],
              colors.secondary[900],
              colors.secondary[400],
              colors.neutral[500],
              colors.neutral[300],
              colors.neutral[900],
              colors.neutral[700],
            ],
          },
          differenceCard: {
            bgColor: colors.neutral[100],
            color: colors.neutral[800],
          },
          infoBox: {
            bgColor: colors.primary[100],
            color: colors.primary[600],
          },
          whatCanIDoStepper: {
            header: {
              bgColor: colors.neutral[100],
              titleColor: colors.neutral[1000],
              color: colors.neutral[700],
              linkColor: colors.primary[500],
            },
            step: {
              titleColor: colors.neutral[800],
              color: colors.neutral[1000],
            },
          },
        },
        layoutButtons: {
          borderColor: colors.neutral[900],
          iconColor: colors.neutral[900],
        },
      },
      tariffs: {
        bgColor: colors.white,
        weakColor: colors.neutral[600],
        color: colors.neutral[1100],
        dividerColor: colors.neutral[200],
        amountText: {
          color: colors.neutral[900],
          bgColor: colors.white,
          borderColor: colors.neutral[300],
        },
        advantageBadge: {
          color: colors.secondary[600],
          bgColor: colors.secondary[100],
          emphasisBgColor: colors.secondary[200],
        },
        carouselButton: {
          bgColor: colors.neutral[100],
          borderColor: colors.neutral[300],
          iconColor: colors.neutral[1100],
        },
        advantageous: {
          bgColor: colors.secondary[500],
          color: colors.white,
          borderColor: colors.secondary[300],
        },
        current: {
          bgColor: colors.neutral[1100],
          color: colors.white,
          borderColor: colors.neutral[600],
        },
        currentAndAdvantageous: {
          bgColor: colors.primary[400],
          color: colors.white,
          borderColor: colors.primary[300],
        },
        default: {
          bgColor: colors.neutral[200],
          color: colors.neutral[900],
          borderColor: colors.neutral[300],
        },
      },
      billingPrediction: {
        chart: {
          seriesColors: [colors.primary[400], colors.secondary[400]],
          areaColor: colors.secondary[400],
        },
        switch: {
          titleColor: colors.neutral[600],
        },
        informationBoxShadowColor: colors.neutral[300],
      },
      mcpPrediction: {
        card: {
          titleColor: colors.neutral[900],
          descriptionColor: colors.neutral[600],
          integerColor: colors.neutral[1100],
          fractionColor: colors.neutral[600],
          unitColor: colors.neutral[1100],
          buttonBgColor: colors.neutral[100],
          buttonBorderHoverColor: colors.neutral[500],
          buttonIconColor: colors.neutral[500],
          subTextColor: colors.neutral[600],
        },
        lineChartColors: [colors.primary[500], colors.secondary[500]],
        heatMapColors: [
          colors.success[600],
          colors.success[300],
          colors.success[200],
          colors.warning[400],
          colors.error[300],
          colors.error[400],
          colors.error[600],
        ],
        itemBorderColor: colors.neutral[100],
      },
      sustainability: {
        switch: {
          titleColor: colors.neutral[600],
        },
        comparisonChartColors: [colors.primary[400], colors.secondary[500]],
      },
      budgetPlanning: {
        lineChartColors: [colors.primary[500], colors.secondary[500]],
        barChartColors: [
          colors.primary[400],
          colors.secondary[500],
          colors.neutral[1000],
        ],
        budgetForm: {
          formDividerBorderColor: colors.neutral[300],
          formBgColor: colors.white,
          formTotalBoxBorderColor: colors.neutral[500],
        },
      },
      administration: {
        modalForm: {
          secondaryButton: {
            bgColor: colors.secondary[100],
            color: colors.secondary[500],
            hoverColor: colors.secondary[400],
            hoverBorderColor: colors.secondary[500],
          },
          sectionTitle: {
            color: colors.primary[500],
            borderColor: colors.primary[500],
          },
          dividerColor: colors.neutral[200],
          sideTitleColor: colors.neutral[600],
          addonColor: colors.neutral[700],
        },
      },
      ososDetail: {
        lineChartColors: [colors.neutral[1100], colors.primary[500]],
        marklineColor: {
          success: colors.success[400],
          warning: colors.warning[400],
          error: colors.error[400],
        },
        gaugeChart: {
          detail: {
            color: colors.neutral[1100],
            lightColor: colors.neutral[500],
          },
          success: {
            color: colors.primary[500],
            progressColor: colors.primary[500],
          },
          warning: {
            color: colors.orange[500],
            progressColor: colors.orange[500],
          },
          error: {
            color: colors.error[500],
            progressColor: colors.error[500],
          },
        },
      },
      sensorCompare: {
        filterForm: {
          headerColor: colors.neutral[800],
          headerBorderColor: colors.neutral[300],
        },
      },
      sensorDetail: {
        switchableChartColors: [
          colors.neutral[900],
          colors.primary[600],
          colors.secondary[600],
          colors.error[600],
          colors.neutral[600],
          colors.primary[300],
          colors.secondary[300],
          colors.error[300],
        ],
      },
      ososOnboarding: {
        multiStepForm: {
          stepNumberColor: colors.neutral[400],
          titleColor: colors.primary[500],
          infoBoxBgColor: colors.primary[100],
          infoBoxBorderColor: colors.primary[500],
          infoBoxColor: colors.primary[500],
          infoColor: colors.neutral[600],
          infoDarkColor: colors.neutral[1000],
          emphasisColor: colors.primary[500],
          ososInfoButton: {
            primary: {
              bgColor: colors.primary[100],
              color: colors.primary[500],
              bgHoverColor: colors.primary[200],
            },
            secondary: {
              bgColor: colors.secondary[100],
              color: colors.secondary[500],
              bgHoverColor: colors.secondary[200],
            },
          },
        },
        ososInfo: {
          titleColor: colors.neutral[1100],
          infoColor: colors.neutral[600],
          infoDarkColor: colors.neutral[1000],
          emphasisColor: colors.primary[500],
          cardBgColor: colors.white,
          infoBoxBgColor: colors.primary[100],
          infoBoxColor: colors.primary[500],
          infoBoxBorderColor: colors.primary[500],
          badgeColor: colors.neutral[600],
          badgeBorderColor: colors.neutral[600],
          toggleButtonColor: colors.primary[500],
          toggleButtonBorderColor: colors.primary[500],
        },
        formResult: {
          titleColor: colors.primary[500],
          color: colors.neutral[900],
          spinnerColor: colors.primary[400],
        },
      },
      generation: {
        weatherCard: {
          weakTextColor: colors.neutral[600],
          unitColor: colors.neutral[800],
        },
      },
    },
    components: {
      tableBadge: {
        primary: {
          borderColor: colors.primary[300],
          color: colors.primary[500],
          bgColor: colors.primary[100],
        },
        secondary: {
          borderColor: colors.secondary[300],
          color: colors.secondary[500],
          bgColor: colors.secondary[100],
        },
        neutral: {
          borderColor: colors.neutral[300],
          color: colors.neutral[500],
          bgColor: colors.neutral[100],
        },
        warning: {
          borderColor: colors.warning[300],
          color: colors.warning[600],
          bgColor: colors.warning[100],
        },
        info: {
          borderColor: colors.info[300],
          color: colors.info[600],
          bgColor: colors.info[100],
        },
        critical: {
          borderColor: colors.error[300],
          color: colors.error[600],
          bgColor: colors.error[100],
        },
      },
      customBadge: {
        warning: {
          bgColor: colors.warning[200],
          color: colors.warning[500],
        },
        error: {
          bgColor: colors.error[200],
          color: colors.error[500],
        },
        success: {
          bgColor: colors.primary[200],
          color: colors.primary[500],
        },
      },

      stepper: {
        activeBgColor: colors.primary[500],
        inactiveBgColor: colors.neutral[200],
        activeLineColor: colors.primary[500],
        inactiveLineColor: colors.neutral[300],
        activeIconColor: colors.white,
        inactiveIconColor: colors.neutral[600],
        activeColor: colors.white,
        inactiveColor: colors.neutral[600],
      },
      table: {
        cellBorderColor: colors.neutral[200],
        actionCellBgColor: colors.white,
        tableBorderColor: colors.neutral[200],
      },
      card: {
        tabBottomBorderColor: colors.neutral[200],
      },
      tableColumnSearchInput: {
        bgColor: colors.white,
      },
      tableColumnsFilter: {
        hoverBgColor: colors.neutral[200],
        borderColor: colors.neutral[300],
        dividerColor: colors.neutral[200],
        infoTextColor: colors.neutral[500],
      },
      tabButtons: {
        bgColor: colors.neutral[200],
        buttonColor: colors.neutral[900],
        activeButtonBgColor: colors.white,
        activeButtonColor: colors.neutral[1100],
      },
      modal: {
        borderColor: colors.neutral[200],
        borderDarkColor: colors.neutral[500],
      },
      useScreenshot: {
        bgColor: colors.white,
      },
      samplingCard: {
        titleColor: colors.neutral[500],
        descriptionColor: colors.neutral[800],
        integerColor: colors.neutral[1100],
        fractionColor: colors.neutral[600],
        unitColor: colors.neutral[1100],
        buttonBgColor: colors.neutral[100],
        buttonBorderHoverColor: colors.neutral[500],
        buttonIconColor: colors.neutral[500],
      },
      chartCard: {
        fullscreenBgColor: colors.white,
      },
      collapserButton: {
        bgColor: colors.neutral[100],
        handlerBgColor: colors.neutral[800],
        handlerHoverColor: colors.neutral[700],
      },
      carbonFootprintCard: {
        primary: {
          bgColor: colors.primary[100],
          iconColor: colors.primary[300],
          valueColor: colors.primary[600],
          subtitleColor: colors.primary[400],
          selectBgColor: colors.primary[200],
          selectHoverBgColor: colors.primary[300],
          selectColor: colors.primary[700],
        },
        info: {
          bgColor: colors.info[100],
          iconColor: colors.info[300],
          valueColor: colors.info[600],
          subtitleColor: colors.info[400],
          selectBgColor: colors.info[200],
          selectHoverBgColor: colors.info[300],
          selectColor: colors.info[700],
        },
        error: {
          bgColor: colors.error[100],
          iconColor: colors.error[300],
          valueColor: colors.error[600],
          subtitleColor: colors.error[400],
          selectBgColor: colors.error[200],
          selectHoverBgColor: colors.error[300],
          selectColor: colors.error[700],
        },
      },
      secondaryButton: {
        bgColor: colors.secondary[600],
        color: colors.white,
        hoverColor: colors.white,
        hoverBgColor: colors.secondary[500],
      },
      generationInfoCard: {
        default: {
          bgColor: colors.white,
          borderColor: colors.neutral[200],
          titleColor: colors.neutral[800],
          numberColor: colors.neutral[1100],
          unitColor: colors.neutral[400],
        },
        highlighted: {
          bgColor: colors.primary[100],
          borderColor: colors.primary[300],
          titleColor: colors.primary[500],
          numberColor: colors.primary[500],
          unitColor: colors.primary[300],
        },
      },
      mapMarkers: {
        clusterPolygonBgColor: colors.neutral[800],
        clusterPolygonBorderColor: colors.neutral[800],
      },
    },
    layouts: {
      authenticationLayout: {
        color: colors.primary[900],
      },
      mainLayout: {
        header: {
          accountButton: {
            bgColor: colors.white,
            buttonColor: colors.neutral[1100],
            buttonBorderColor: colors.neutral[300],
            boxBgColor: colors.neutral[100],
            boxBorderColor: colors.neutral[300],
            boxButtonBgColor: colors.white,
            boxButtonBorderColor: colors.neutral[1000],
            companyTextColor: colors.neutral[900],
            nameTextColor: colors.neutral[600],
            statusTextColor: colors.neutral[400],
          },
          toolButton: {
            bgColor: "transparent",
            hoverBgColor: colors.white,
            iconColor: colors.neutral[1100],
            hoverIconColor: colors.neutral[1000],
          },
          notifications: {
            contentColor: colors.neutral[1100],
            timeColor: colors.neutral[600],
            groupTitleColor: colors.neutral[800],
            dividerColor: colors.neutral[200],
            criticalIconColor: colors.error[500],
            infoIconColor: colors.info[500],
            warningIconColor: colors.warning[500],
            numberBadgeBgColor: colors.error[500],
          },
        },
        sidebar: {
          versionText: {
            bgColor: colors.neutral[100],
            startColor: colors.primary[500],
            endColor: colors.secondary[500],
          },
          menu: {
            bgColor: "transparent",
          },
          menuItem: {
            hoverBgColor: colors.neutral[100],
            titleColor: colors.neutral[500],
            selectedItemBgColor: colors.neutral[1000],
            selectedItemColor: colors.white,
            submenuIconColor: colors.neutral[500],
          },
        },
        triggerButton: {
          iconColor: colors.neutral[500],
          iconHoverColor: colors.neutral[900],
          bgHoverColor: colors.neutral[200],
        },
      },
    },
  };
};
